export default __webpack_public_path__ + "static/media/upArrow.a8e464ae.svg";